__turbopack_context__.v({
  "button": "g4gLLq_button",
  "content2": "g4gLLq_content2",
  "freeBox": "g4gLLq_freeBox",
  "img": "g4gLLq_img",
  "link": "g4gLLq_link",
  "news": "g4gLLq_news",
  "newsDivider": "g4gLLq_newsDivider",
  "newsExcerpts": "g4gLLq_newsExcerpts",
  "newsItem": "g4gLLq_newsItem",
  "newsItemPlaceholder": "g4gLLq_newsItemPlaceholder",
  "newsProvider": "g4gLLq_newsProvider",
  "svg__ctYXi": "g4gLLq_svg__ctYXi",
  "svg__eWp0J": "g4gLLq_svg__eWp0J",
  "title": "g4gLLq_title",
});
